<booking-address-mobile *ngIf="isMobile"></booking-address-mobile>
<booking-address-desktop *ngIf="!isMobile"></booking-address-desktop>